exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".leavePromptModalContainer___30X4e {\n  padding: 40px;\n}\n.leavePromptModalContainer___30X4e .header___UWURP {\n  font-size: 20px;\n  font-weight: 600;\n}\n.leavePromptModalContainer___30X4e .buttonContainer___KAphr {\n  padding-top: 32px;\n  display: flex;\n  flex-direction: row-reverse;\n}\n.leavePromptModalContainer___30X4e .buttonPadding___tqOkm {\n  margin-right: 12px;\n}\n", ""]);

// exports
exports.locals = {
	"leavePromptModalContainer": "leavePromptModalContainer___30X4e",
	"header": "header___UWURP",
	"buttonContainer": "buttonContainer___KAphr",
	"buttonPadding": "buttonPadding___tqOkm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/pages/Events/LeavePromptModal/LeavePromptModal.module.less
// module id = 2615
// module chunks = 51